// For the US upfront fees pla's both the main feed and regional id's will have PLA_US_FEED_PARAM_KEY set to PLA_US_FEED_PARAM_VALUE
export const PLA_US_FEED_PARAM_KEY = 'pla_feed';
export const PLA_US_FEED_PARAM_VALUE = 'us';
export const PLA_COUNTRY_CODE_PARAM_KEY = 'country_code';
export const PLA_COUNTRY_CODE_PARAM_VALUES = ['au', 'gb'];

/*
  When PLA_US_FEED_PARAM_KEY === PLA_US_FEED_PARAM_VALUE we internally set the region id value
  to PLA_US_FEED_PARAM_REGION_ID value so that we can override the region id
*/
export const PLA_US_FEED_PARAM_REGION_ID = 'us_no_fees';
export const PLA_US_REGION_ID_PARAM_KEY = 'region_id';
// The upfront fees regional pricing pla feed query param value
export const PLA_US_REGION_ID_PARAM_VALUE = 'upfront_fees';
// The inclusive pricing regional pla feed query param value
export const PLA_US_INCLUSIVE_PRICING_REGION_ID_PARAM_VALUE =
  'inclusive_pricing';
// Mapping between PLA region ids and cloudflare region header values
export const REGION_ID_TO_X_REGION_CODE: Record<string, string> = {
  // here we map to a state that IS in the optimizely audience for upfront fees
  upfront_fees: 'ca',
  inclusive_pricing: 'ct',
  // here we map to a state that is NOT in the optimizely audience for upfront fees
  [PLA_US_FEED_PARAM_REGION_ID]: 'tx',
};
